/**
 * Checks if the current device is a desktop based on platform identifier
 * or window dimensions as a fallback
 */
const isDesktop = (platform?: string): boolean => {
  // First check platform identifiers
  const isDesktopPlatform = platform
    ? ["macos", "tdesktop", "weba", "web", "webk"].includes(
        platform.toLowerCase()
      )
    : false;

  // If platform check fails, use screen size as a fallback
  if (!isDesktopPlatform && typeof window !== "undefined") {
    // Most phones are under 1000px wide, so this is a reasonable threshold
    return window.innerWidth >= 1024;
  }

  return isDesktopPlatform;
};

export default isDesktop;
